var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.context)?_c('div',{class:(_vm.$vuetify.breakpoint.mobile) ? 'px-2': '',attrs:{"id":"footer-wrapper"}},[_vm._l((_vm.context),function(oneFooter,index){return [_c('dynamic-section',{key:index,attrs:{"context":oneFooter}})]}),_c('img',{attrs:{"src":"https://abc.herbalgram.org/site/PixelServer"}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }